<template>
  <!-- NOTE (TEMPLATE) to show the university login page -->

  <div class="app animated fadeIn flex-row align-items-center companyBack">
    <!-- loading component -->
    <Loading />

    <div class="container">
      <b-row class="justify-content-center">
        <h1 class="mb-5 text-white" style="color: #fff">
          شرکت گرامی، به سامانه تقسیم کار ملی خوش آمدید!
        </h1>

        <b-col md="8">
          <b-card-group>
            <b-card no-body class="login-card p-4 pb-2">
              <b-card-body>
                <div v-if="!codeSent">
                  <p class="text-muted">
                    لطفا برای ورود به سیستم و دریافت رمز عبور یکبار مصرف از طریق
                    پیامک،
                    <b>نام کاربری</b> خود را وارد کنید.
                  </p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>

                    <b-form-input
                      trim
                      type="text"
                      v-model="username"
                      class="form-control"
                      placeholder="نام کاربری"
                      @keyup.enter.native="sendCode"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <!-- NOTE (b-login) to go to the university dashboard -->
                      <b-button
                        v-if="!isBusy"
                        type="submit"
                        variant="primary"
                        @click="sendCode()"
                        style="border: 0"
                        :disabled="busy || isBusy || !username"
                        class="btn-radius px-8 py-2 mt-4"
                      >
                        <i class="icon-login"></i>ارسال کد یکبارمصرف
                      </b-button>

                      <b-spinner v-else class="align-middle"></b-spinner>
                    </b-col>
                    <b-col> &nbsp; </b-col>

                    <b-col cols="6" class="text-right"></b-col>
                  </b-row>
                </div>
                <div v-else>
                  <p class="text-muted">
                    جهت ورود، کد یکبارمصرف پیامک شده را وارد نمایید
                  </p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>

                    <b-form-input
                      trim
                      type="text"
                      v-model="activationCode"
                      class="form-control"
                      placeholder="کد یکبارمصرف"
                      @keyup.enter.native="activationCode ? login() : ''"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <!-- NOTE (b-login) to go to the university dashboard -->
                      <b-button
                        v-if="!busy"
                        type="submit"
                        variant="primary"
                        @click="login()"
                        style="border: 0"
                        :disabled="busy || isBusy || !activationCode"
                      >
                        <i class="icon-login"></i>ورود
                      </b-button>

                      <b-spinner v-else class="align-middle"></b-spinner>
                    </b-col>
                    <b-col class="text-left" cols="6">
                      <b-button
                        type="submit"
                        variant="info"
                        @click="changeNumber()"
                        style="border: 0"
                        :disabled="busy"
                      >
                        <b-icon icon="arrow-counterclockwise"></b-icon>تغییر نام
                        کاربری
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="6">&nbsp;</b-col>
                    <b-col cols="6" class="text-left">
                      <!-- NOTE (b-sendAgain) to get the activation code again -->
                      <b-button
                        type="submit"
                        variant="info"
                        @click="resendCode()"
                        style="border: 0"
                        :disabled="sendAgainDisbaled"
                      >
                        <b-icon icon="arrow-counterclockwise"></b-icon>ارسال
                        مجدد کد
                        <span v-if="countdown != 0">{{
                          toHHMMSS(countdown)
                        }}</span>
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </b-card-body>
              <div>
                <b-row></b-row>
              </div>
            </b-card>
          </b-card-group>
          <b-row class="justify-content-center mt-5">
            <v-btn
              color="indigo lighten-2"
              @click="goTo('admin')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود مدیر
            </v-btn>
            <v-btn
              color="red darken-3"
              @click="goTo('ref')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود داور
            </v-btn>
            <v-btn
              color="purple darken-1"
              @click="goTo('researcher')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود پژوهشگر
            </v-btn>
            <v-btn
              color="deep-orange lighten-1"
              @click="goTo('accelerator')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود شتاب‌دهنده
            </v-btn>
            <v-btn
              color="teal"
              @click="goTo('uni')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود دانشگاه
            </v-btn>
          </b-row>
          <hr class="mt-6" />
          <b-row class="justify-content-center mt-3">
            <v-btn
              color="blue darken-1"
              to="/map"
              class="m-1 white--text btn-radius"
              height="42"
              elevation="0"
            >
              <v-icon class="me-1">mdi-map</v-icon>نقشه تعاملی زیست فناوری
            </v-btn>
            <v-btn
              color="yellow darken-1"
              class="m-1 black--text btn-radius"
              height="42"
              elevation="0"
              @click="faqDialog = true"
            >
              <v-icon class="me-1">mdi-frequently-asked-questions</v-icon>سوالات
              متداول
            </v-btn>
            <v-btn
              color="orange darken-1"
              href="https://api.biodcportal.com/setad/public/طرح%20تقسیم%20کار%20ملی%20زیست%20فناوری.pdf"
              class="m-1 white--text btn-radius"
              height="42"
              elevation="0"
            >
              راهنمای آشنایی با طرح تقسیم کار ملی زیست فناوری
            </v-btn>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <FaqDialogue :faq-dialog.sync="faqDialog" />
  </div>
</template>

<script>
const FaqDialogue = () => import("../components/FaqDialogue");
export default {
  name: "Login",
  components: { FaqDialogue },
  data() {
    return {
      username: "",
      password: "",
      busy: false,
      isBusy: false,

      codeSent: false,
      activationCode: "",
      newPass: "",
      repeatNewPass: "",
      countdown: 60,
      sendAgainDisbaled: false,
      rec_has_number: false,
      rec_has_lowercase: false,
      rec_has_uppercase: false,
      faqDialog: false,
    };
  },
  watch: {
    codeSent: function (val, oldVal) {
      // NOTE (w-codeSent) to give the code again after 60 second
      this.countdown = 60;

      if (val == true) {
        this.sendAgainDisbaled = true;
        this.countDownTimer();
      }
    },
    countdown: function (val, oldVal) {
      // NOTE (w-countdown) to countdown for sending code again
      if (val == 0) {
        this.sendAgainDisbaled = false;
      } else {
        if (val > 0) {
          this.sendAgainDisbaled = true;
        } else {
          this.countdown = 0;
          this.sendAgainDisbaled = false;
        }
      }
    },
  },
  methods: {
    goTo(role) {
      if (role == "admin") {
        this.$router.push("/adminloginsolid");
      } else if (role == "ref") {
        this.$router.push("/refloginsolid");
      } else if (role == "researcher") {
        this.$router.push("/loginsolid");
      } else if (role == "uni") {
        this.$router.push("/uniloginsolid");
      } else if (role == "accelerator") {
        this.$router.push("/acceleratorLoginsolid");
      }
    },
    sendCode() {
      this.isBusy = true;
      this.codeSent = false;
      this.$http
        .post(this.baseUrl + "/setad/authentication/companyLogin", {
          username: this.username,
        })
        .then((res) => {
          this.isBusy = false;

          if (res.status == 200) {
            this.codeSent = true;
          } else {
            const title = (
              <div>
                <h5>خطا</h5>
                <span>خطایی رخ داده است. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.isBusy = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    login() {
      this.busy = true;
      this.$http
        .post(this.baseUrl + "/setad/authentication/companyEntrance", {
          username: this.username,
          activationcode: this.activationCode,
        })
        .then((res) => {
          this.busy = false;

          if (res.status == 200) {
            localStorage.setItem("userId", res.data.token);
            localStorage.setItem("role", "company");
            localStorage.setItem("username", res.data.name);
            this.$route.query.return
              ? this.$router.push(this.$route.query.return)
              : this.$router.push("/company/dashboard");
          } else {
            const title = (
              <div>
                <h5>خطا</h5>
                <span>خطایی رخ داده است. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.isBusy = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    changeNumber() {
      // NOTE (m-changeNumber) to change the number
      this.countdown = 0;
      this.codeSent = false;
    },
    resendCode() {
      this.countdownGone = false;
      this.sendCode();
    },
    toHHMMSS(value) {
      // NOTE (m-toHHMMSS) determine the order of hours, minutes and seconds
      var sec_num = parseInt(value, 10); // don't forget the second param
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = sec_num - hours * 3600 - minutes * 60;

      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return minutes + ":" + seconds;
    },
    countDownTimer() {
      //NOTE (m-countDownTimer) to start counting down after 1 second
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
  },
};
</script>
<style scoped>
.companyBack {
  background-image: url("../assets/images/companyBack.png");

  background-size: cover;
}
/* pass validation style */
.pass {
  font-size: 13px;
}
.pass--passed {
  color: #717b85;
}
.frmIcon {
  color: #eb0029;
}
.pass--passed .frmIcon {
  color: #0fa140;
}
</style>
